// geoLocation.js
var DKT = DKT || {};
DKT.geoLocation = function(
  $,
  L,
  DKTConfiguration,
  DKTUtils,
  DKTMap,
  tamborradasPorZona_cosa,
  geolocationLink,
  translations,
  zonesLinks,
  existeGoogleAnalytics
) {
  function init() {
    var now = new Date();
    var tamborradaDate = new Date(DKTConfiguration.TAMBORRADA_DAY + "T00:00");

    if (DKTUtils.isSameDay(now, tamborradaDate)) {
      showButton();
      subscribeListeners();
    }
  }

  function showButton() {
    $(".aqui-ahora").css("display", "inline-block");
  }

  function subscribeListeners() {
    $(".aqui-ahora").on("click", goToGeoLocationPage);
  }

  function goToGeoLocationPage() {
    window.location.href = geolocationLink;
    if (existeGoogleAnalytics) ga("gtm1.send", "event", "geolocalizacion", "click", window.location.href);
  }

  function initGeoLocationPage() {
    setTimeout(geoLocate, 3000);
    selectRandomPhrase();
  }

  function selectRandomPhrase() {
    var geolocationPhrases = $(".geolocation-phrase");
    var geolocationPhrasesNumber = geolocationPhrases.length;
    var phraseIndex = Math.floor(Math.random() * geolocationPhrasesNumber);    
    $(geolocationPhrases.get(phraseIndex)).css("display", "block");
  }

  function geoLocate() {
    navigator.geolocation.getCurrentPosition(onGeoLocationSuccessful, onGeoLocationError);
  }

  function onGeoLocationSuccessful(position) {
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    var latlng = L.latLng(lat, lng);

    var zone = getZoneFromPosition(latlng);
    if (zone) {
      var zonesLinksFiltered = zonesLinks.filter(function(item) {
        return item.id == zone.id;
      });
      if (zonesLinksFiltered.length > 0) {
        var zoneLink = zonesLinksFiltered[0].url;
      }
      if (zoneLink) {
        window.location.href = zoneLink;
      }
    } else {
      console.log("No se ha encontrado zona");
      alert(translations.noZone);
      window.history.back();
    }
  }

  function onGeoLocationError(error) {
    switch (error.code) {
    case 1: // Access to location denied
      console.log(error.message);
      console.log("Debes dar permiso de acceso a tu ubicación para utilizar esta funcionalidad");
      alert(translations.errorPermission);
      window.history.back();
      break;
    case 2: // Position is unavailable
      console.log(error.message);
      console.log("No se pudo recuperar tu posición satisfactoriamente.");
      alert(translations.errorGPS);
      window.history.back();
      break;
    case 3: // Timeout
      console.log(error.message);
      console.log("No se pudo recuperar tu posición satisfactoriamente.");
      alert(translations.errorGPS);
      window.history.back();
      break;
    }
  }

  function getZoneFromPosition(latlng) {
    var quarterAreas = DKTMap.getQuarterAreas();
    var actualQuarterArea = null;

    for (var i = 0; i < quarterAreas.length; i++) {
      var quarterArea = quarterAreas[i];
      var quarterPolygon = L.geoJson(quarterArea.polygon.toGeoJSON());
      if (leafletPip.pointInLayer(latlng, quarterPolygon, true).length > 0) {
        actualQuarterArea = quarterArea;
        break;
      }
    }

    if (actualQuarterArea) {
      var zones = [];
      for (var i = 0; i < tamborradasPorZona_cosa.length; i++) {
        var actualZone = tamborradasPorZona_cosa[i];
        var isTheZone = false;
        for (var j = 0; j < actualZone.BAR_BARR.length; j++) {
          if (actualZone.BAR_BARR[j] == actualQuarterArea.BAR_BARR) {
            isTheZone = true;
            break;
          }
        }
        if (isTheZone) {
          zones.push(actualZone);
        }
      }

      if (zones.length > 0) {
        if (zones.length > 1) {
          var knownConflictCentro = ["13", "16"];
          if (
            zones[0].id == knownConflictCentro[0] && zones[1].id == knownConflictCentro[1] ||
            zones[0].id == knownConflictCentro[1] && zones[1].id == knownConflictCentro[0]
          ) {
            var limit = [43.321682, -1.985037];
            if (latlng.lat >= limit[0]) {
              if (zones[0].id == "16") return zones[0];
              else return zones[1];
            } else {
              if (zones[0].id == "13") return zones[0];
              else return zones[1];
            }
          } else {
            var minDistance = 50000;
            var minDistanceIndex = null;
            zones.forEach(function(zone, index) {
              var distance = DKTUtils.getDistanceFromLatLonInKm(
                latlng.lat,
                latlng.lon,
                zone.markerPosition[0],
                zone.markerPosition[1]
              );
              if (distance < minDistance) {
                minDistance = distance;
                minDistanceIndex = index;
              }
            });

            if (minDistanceIndex != null) {
              return zones[minDistanceIndex];
            } else {
              return zones[0];
            }
          }
        } else {
          return zones[0];
        }
      }
    }

    return null;
  }

  return { 
    init: init, 
    initGeoLocationPage: initGeoLocationPage
  };
};
